<template>
  <list-obligations
    @save="onSave"
    @delete="onDeleteAdhoc"
    :obligations="obligations"
    :name="vehicle.description"
    :type="resx.labels.vehicle_obligation"
    :heading="heading"
    :details="details"
  >
    <template v-if="isSystemUser && vehicle._id" #notes>
      <v-row class="mx-0">
        <v-col cols="12" md="6" class="pa-0">
          <notes-panel
            fill
            scope="vehicleObligations"
            :contractor-id="contractor._id"
            :value="vehicle.notes"
            :size="contractor.notesSize && contractor.notesSize.vehicleObligations"
            :save-value="v => saveText('notes', v)"
            @saved="v => onTextSaved('notes', v)"
          >
          </notes-panel>
        </v-col>
        <v-col cols="12" md="6" class="pa-0">
          <notes-panel
            fill
            scope="vehicleObligations"
            :label="resx.labels.comments_visible_to_company"
            :resizable="false"
            :value="vehicle.comments"
            :save-value="v => saveText('comments', v)"
            @saved="v => onTextSaved('comments', v)"
          >
          </notes-panel>
        </v-col>
      </v-row>
    </template>
  </list-obligations>
</template>

<script>
"use strict";

import contractorCompanyService from "@/services/ContractorCompanyService";

import roles from "@/utils/roles";
import notesPanel from "../notes-panel.vue";
import listObligations from "../obligations/obligations.view.vue";

export default {
  async mounted() {
    this.contractor = await contractorCompanyService.getById(
      this.$route.params.id
    );
    this.vehicle = this.contractor.vehicles.find(
      v => v._id == this.$route.params.vid
    );
    this.obligations = await contractorCompanyService.getObligations(
      this.$route.params.id,
      this.$store.state.constants.OBLIGATIONS.TYPES.VEHICLE_OBLIGATION,
      { id: this.vehicle._id, typeId: this.vehicle.type._id }
    );
  },
  components: {
    listObligations,
    notesPanel
  },
  computed: {
    // Las notas y los comentarios son del personal del sistema.
    isSystemUser() {
      return roles.loggedUserHasRoles(
        this.$store.state.auth.user.roles,
        this.$store.state.constants.roles.ALL_SYS_ROLES
      );
    },
    heading() {
      return "Obligaciones del vehículo";
    },
    // Patente y tipo, los que esten cargados.
    details() {
      const vehicle = this.vehicle;
      const details = [];
      if (vehicle.uniqueIdentifier) {
        details.push({ label: "Patente", value: vehicle.uniqueIdentifier });
      }
      if (vehicle.type && vehicle.type.name) {
        details.push({ label: "Tipo", value: vehicle.type.name });
      }
      return details;
    }
  },
  data() {
    return {
      obligations: [],
      contractor: {},
      vehicle: {}
    };
  },
  methods: {
    saveText(field, value) {
      return contractorCompanyService.editReferenceText(
        this.$route.params.id,
        "vehicles",
        this.vehicle._id,
        field,
        value
      );
    },
    // Se guarda tambien en el objeto local para que el valor sobreviva a un
    // nuevo render del panel.
    onTextSaved(field, value) {
      this.$set(this.vehicle, field, value);
    },
    async onSave(action) {
      action.item.referenceId = this.vehicle._id;
      const contractor = action.isNew
        ? await contractorCompanyService.addObligation(
            this.$route.params.id,
            action.item
          )
        : await contractorCompanyService.editObligation(
            this.$route.params.id,
            action.item
          );
      if (contractor) {
        this.obligations = await contractorCompanyService.getObligations(
          this.$route.params.id,
          this.$store.state.constants.OBLIGATIONS.TYPES.VEHICLE_OBLIGATION,
          { id: this.vehicle._id, typeId: this.vehicle.type._id }
        );
      }
    },
    async onDeleteAdhoc(item) {
      let contractor = await contractorCompanyService.deleteObligation(
        this.$route.params.id,
        item
      );
      if (contractor) {
        this.obligations = await contractorCompanyService.getObligations(
          this.$route.params.id,
          this.$store.state.constants.OBLIGATIONS.TYPES.VEHICLE_OBLIGATION,
          { id: this.vehicle._id, typeId: this.vehicle.type._id }
        );
      }
    }
  },
  mixins: []
};
</script>
